import { Skeleton } from "@/shared/ui";

export default function CalculationsPageSkeleton() {
  return (
    <>
      <div className="p-5 radius-lg border surface-component-stroke mb-5">
        <div className="flex items-start justify-between gap-4 mb-5">
          <div className="flex items-center gap-3">
            <Skeleton width={40} height={40} borderRadius={8} />
            <div className="flex flex-col gap-1">
              <Skeleton height={20} width={280} />
              <Skeleton height={16} width={160} />
            </div>
          </div>
          <Skeleton height={16} width={200} />
        </div>

        <div className="grid grid-cols-[auto_1fr] gap-5 items-center">
          <Skeleton width={210} height={210} borderRadius={105} />

          <div className="grid grid-cols-3 gap-2">
            {Array.from({ length: 3 }).map((_, idx) => (
              <div key={idx} className="p-5 radius-lg border surface-component-stroke flex flex-col">
                <div className="flex items-center gap-3 mb-3">
                  <Skeleton width={32} height={32} borderRadius={4} />
                  <Skeleton height={14} width={100} />
                </div>
                <Skeleton height={32} width="70%" />
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="mb-4">
        <Skeleton height={20} width={260} />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="p-6 radius-lg border surface-component-stroke flex flex-col gap-4 row-span-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Skeleton width={40} height={40} borderRadius={6} />
              <div className="flex flex-col gap-1">
                <Skeleton height={18} width={120} />
                <Skeleton height={14} width={180} />
              </div>
            </div>
            <Skeleton height={24} width={100} borderRadius={6} />
          </div>
          <Skeleton height={32} width="50%" />
          <div className="flex gap-1">
            {Array.from({ length: 3 }).map((_, idx) => (
              <Skeleton key={idx} height={28} width={90} borderRadius={6} />
            ))}
          </div>
          <div className="p-4 radius-md surface-component-fill flex flex-col gap-2">
            <Skeleton height={12} width={120} />
            <Skeleton height={14} width="80%" />
            <Skeleton height={14} width="60%" />
          </div>
        </div>

        {Array.from({ length: 3 }).map((_, idx) => (
          <div key={idx} className="p-4 radius-lg border surface-component-stroke flex flex-col gap-3">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Skeleton width={24} height={24} borderRadius={6} />
                <div className="flex flex-col gap-1">
                  <Skeleton height={14} width={80} />
                  <Skeleton height={12} width={120} />
                </div>
              </div>
              <Skeleton height={22} width={100} borderRadius={6} />
            </div>
            <div className="flex flex-col gap-1">
              <div className="flex items-center justify-between">
                <Skeleton height={12} width="60%" />
                <Skeleton height={12} width={60} />
              </div>
            </div>
            <Skeleton height={14} width="50%" />
          </div>
        ))}
      </div>
    </>
  );
}
